'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardCapslock = function HardwareKeyboardCapslock(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z' })
  );
};
HardwareKeyboardCapslock = (0, _pure2.default)(HardwareKeyboardCapslock);
HardwareKeyboardCapslock.displayName = 'HardwareKeyboardCapslock';
HardwareKeyboardCapslock.muiName = 'SvgIcon';

exports.default = HardwareKeyboardCapslock;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/hardware/keyboard-capslock.js
 ** module id = 1987
 ** module chunks = 0
 **/